import { Component } from 'react'
import PropTypes from 'prop-types'

export default class Stopwatch extends Component {
  static propTypes = {
    from: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    to: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }

  state = {
    days: `00`,
    hours: `00`,
    minutes: `00`,
    seconds: `00`,
  }

  componentDidMount() {
    this.initDateFrom()
    this.initDateTo()
    this.initTimer()
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  initTimer() {
    const tick = () => {
      const diff = this.dateTo.getTime() - this.dateNow.getTime()
      const days = this.format(Math.floor(diff / 1000 / 60 / 60 / 24))
      const hours = this.format(Math.floor(diff / 1000 / 60 / 60) % 24)
      const minutes = this.format(Math.floor((diff / 1000 / 60) % 60))
      const seconds = this.format(Math.floor((diff / 1000) % 60))
      this.setState({
        days,
        hours,
        minutes,
        seconds,
      })
      this.dateNow = new Date()
      if (diff <= 0) {
        clearInterval(this.timer)
      }
    }
    this.timer = setInterval(tick, 1000)
  }
  initDateFrom() {
    const { from } = this.props
    if (typeof from === `string`) {
      if (from === `now`) {
        this.dateFrom = new Date()
        this.dateNow = this.dateFrom
      }
    } else if (typeof from === `number`) {
      this.dateFrom = new Date(from)
      this.dateNow = this.dateFrom
    }
  }
  initDateTo() {
    const { to } = this.props
    if (typeof to === `string`) {
      if (to === `next-day`) {
        const today = new Date()
        const tomorrow = new Date()

        tomorrow.setDate(today.getDate() + 1)
        tomorrow.setHours(0, 0, 0, 0)
        this.dateTo = tomorrow
      } else {
        this.dateTo = new Date(to)
      }
    } else if (typeof to === `number`) {
      this.dateTo = new Date(to)
    }
  }
  format(num) {
    if (num < 10) {
      return `0${num}`
    }
    return `${num}`
  }

  render() {
    const { days, hours, minutes, seconds } = this.state
    return `${days !== '00' ? days + 'дн. ' : ''}${hours}:${minutes}:${seconds}`
  }
}
